import { ModalLayout } from "lib/modal/ModalLayout";
import PropTypes from "prop-types";
import { backboneConnect } from "lib/common/hoc/BackboneReact/backboneConnect";
import React from "react";
import Dispatcher from "Dispatcher";
import ModalActions from "controllers/ModalActions";

/**
 * I convert a given component into a modal, using the supplied options. Options
 * may be a string (for the title) or an object containing title and size keys.
 * If not specified, size will be "lg".
 */
const asModal = options => WrappedComponent => {
    if (typeof options === "string") {
        options = {
            title: options,
        };
    }
    const {
        title = "Untitled Modal",
        size = "lg",
    } = options;
    const Modal = (props) =>
        <ModalLayout
            title={title}
            size={size}
            triggerClose={props.triggerClose}
        >
            <WrappedComponent {...props} />
        </ModalLayout>;

    Modal.propTypes = {
        triggerClose: PropTypes.func.isRequired
    };

    Modal.displayName = `Modal(${WrappedComponent.displayName || WrappedComponent.name || "Component"})`;

    const config = props => ({
        triggerClose: () => {
            props.view.trigger("close");
            Dispatcher.dispatch({
                type: ModalActions.CLOSE,
            });
        }
    });

    return backboneConnect(config)(Modal);
};

export default asModal;



// WEBPACK FOOTER //
// ./app/lib/modal/asModal.js